import {
  defaultBrandFilter,
  defaultClientFilter,
  defaultProjectNameFilter,
  defaultRegionsFilter,
  defaultSelectFilterFields,
} from 'pages/Home/utils'
import { FilterComponentData } from 'reducers/GenericFiltersReducer/GenericFiltersReducer.d'

export const projectTableFilters: FilterComponentData[] = [
  defaultClientFilter,
  defaultBrandFilter,
  defaultRegionsFilter,
  {
    ...defaultSelectFilterFields,
    id: 'statuses',
    labelText: 'Status',
    isMultiSelect: true,
    options: [
      { id: 'all', value: 'All' },
      { id: 'draft', value: 'Draft' },
      { id: 'in_progress', value: 'In progress' },
      { id: 'completed', value: 'Generation Complete' },
    ],
    defaultValue: { id: 'all', value: 'All' },
  },
  {
    ...defaultProjectNameFilter,
    id: 'names',
    labelText: '',
    placeholder: 'Search by project title',
    isMultiSelect: false,
  },
]
